// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.1218 13.4647L23.536 14.8789L21.4147 17.0002L23.536 19.1215L22.1218 20.5358L20.0005 18.4144L17.8791 20.5358L16.4649 19.1215L18.5862 17.0002L16.4649 14.8789L17.8791 13.4647L20.0005 15.586L22.1218 13.4647Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 3H21L14 12.8174V21H10V12.8174L3 3Z"}}]};

const FilterClearFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'filter-clear-filled',
    ref,
    icon: element,
  },
));

FilterClearFilledIcon.displayName = 'FilterClearFilledIcon';

export default FilterClearFilledIcon;
